// extracted by mini-css-extract-plugin
export default {"disclaimer":"Disclaimer_disclaimer__RaJwp"};